/**
 * 세션은 프로젝트 단위다 (2026-10-01).
 *
 * 예전에는 탭마다 따로 세션을 골랐다. 그래서 세션을 고른 탭에서 다른 탭으로 가면 「세션 미선택」이 되어
 * 세션이 사라진 것처럼 보였다(신고). 이제 고르면 **그 탭이 속한 프로젝트의 모든 탭**(프로젝트가 없으면
 * 기본 작업공간의 모든 탭)에 걸고, 새로 생기는 탭은 그 세션을 물려받는다.
 *
 * 프로젝트 쪽 상태를 따로 두지 않고 탭에서 읽는다 — 탭의 `sessionId` 가 실행 경로가 실제로 보는 값이라,
 * 두 곳에 두면 「화면에 보이는 세션」과 「실행되는 세션」이 갈라진다.
 */

const pidOf = (f) => (f && f.projectId) || null;

/** 그 프로젝트(null = 기본 작업공간)의 세션 — 탭 중 세션이 걸린 첫 것 */
export function projectSessionOf(files, projectId) {
    const pid = projectId || null;
    const hit = (files || []).find(f => pidOf(f) === pid && f.sessionId);
    return hit ? hit.sessionId : null;
}

/**
 * 탭 하나에서 고른 세션을 그 프로젝트의 모든 탭에 건다.
 *
 * @param isBusy (sessionId) => boolean — **실행 중인 세션에 묶인 탭은 건드리지 않는다.** 그 탭의 중지 버튼·
 *   다음 페이지가 탭의 sessionId 를 보므로, 바꿔 버리면 돌고 있는 쿼리를 멈출 수 없게 된다.
 */
export function bindSessionToProject(files, fileId, sessionId, isBusy = () => false) {
    const target = (files || []).find(f => f.id === fileId);
    if (!target) return files;
    const pid = pidOf(target);
    let changed = false;
    const next = files.map(f => {
        if (pidOf(f) !== pid) return f;
        if (f.sessionId === sessionId) return f;
        if (f.id !== fileId && f.sessionId && isBusy(f.sessionId)) return f;
        changed = true;
        return { ...f, sessionId };
    });
    return changed ? next : files;
}
